import { render, staticRenderFns } from "./TrafficTopButton.vue?vue&type=template&id=00f70a5c&scoped=true&"
import script from "./TrafficTopButton.vue?vue&type=script&lang=js&"
export * from "./TrafficTopButton.vue?vue&type=script&lang=js&"
import style0 from "./TrafficTopButton.vue?vue&type=style&index=0&id=00f70a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f70a5c",
  null
  
)

export default component.exports